import React from 'react';
import './App.css';
import Stroop from '../../util/Stroop';
import Title from '../Title/Title';
import GameFrame from '../GameFrame/GameFrame';
import Footer from '../Footer/Footer';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "Menu",
      activeEvent: false,
      round: 1,
      eventIndex: 0,
      roundScore: 0,
      totalScore: 0,
      highScore: Stroop.totalScore,
      snagBonus: 1,
      buttonArray: Stroop.buttonArray,
      buttons: Stroop.buttons,
      rotation: Stroop.rotation,
      snagInfo: Stroop.snagInfo,
      showSnags: false,
      unreadSnags: false,
      questionStyle: {
        color: "white",
        outlineColor: "black"
      }
    }
    this.beginGame = this.beginGame.bind(this);
    this.respond = this.respond.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.showSnags = this.showSnags.bind(this);
    this.hideSnags = this.hideSnags.bind(this);
  }

  beginGame() {
    Stroop.beginGame();
    this.setState({
      mode: Stroop.mode,
      round: Stroop.round,
      roundScore: Stroop.roundScore,
      totalScore: Stroop.totalScore,
      showSnags: false
    });
    this.revealSequence(Stroop.revealIndex);
  }

  revealSequence(revealIndex) {
    Stroop.beginEventReveal(Stroop.revealArray[revealIndex]);
    this.setState({
      mode: Stroop.mode,
      rotation: Stroop.rotation,
      snagBonus: Stroop.snagBonus,
      unreadSnags: Stroop.unreadSnags
    });
    setTimeout(function() {
      Stroop.endEventReveal(revealIndex);
      this.setState({mode: Stroop.mode});
      setTimeout(function() {
        Stroop.revealIndex++;
        if (Stroop.revealIndex < Stroop.revealArray.length) {
          this.revealSequence(Stroop.revealIndex);
        }
      }.bind(this), 100);
    }.bind(this), Stroop.revealArray[revealIndex][2] * 1000);
  }

  closeEvent() {
    Stroop.buttonArray.forEach(button => {
      if (button.active) {
        button.off();
      }
    });
    Stroop.eventIndex++;
    if (Stroop.eventIndex >= Stroop.eventArray.length) {
      Stroop.respondIndex = 0;
      this.setState({
        buttons: Stroop.buttons,
        activeEvent: false,
        mode: "Responding"});
    } else {
      Stroop.eventArray[Stroop.eventIndex].smooth();
      setTimeout(function() {this.closeEvent()}.bind(this), 1000);
    }
  }

  nextEvent() {
    Stroop.buttons.red.smooth();
  }

  handleMouseOver(color) {
    if (Stroop.buttons[color].active) {
      Stroop.buttons[color].lightOn();
      this.setState({mode: "Responding"});
    }
  }

  handleMouseLeave(color) {
    if (Stroop.buttons[color].active) {
      Stroop.buttons[color].lightOff();
      this.setState({mode: "Responding"});
    }
  }

  respond(color) {
    Stroop.respond(color);
    //Stroop.updateReadSnags();
    this.setState({
      mode: Stroop.mode,
      roundScore: Stroop.roundScore,
      totalScore: Stroop.totalScore,
      highScore: Stroop.highScore,
      buttons: Stroop.buttons,
      rotation: Stroop.rotation,
      snagInfo: Stroop.snagInfo,
      unreadSnags: Stroop.unreadSnags
    });
    if (this.state.unreadSnags) {
      this.setState({
        questionStyle: {
          color: "black",
          outlineColor: "red"
        }
      })
    } else {
      this.setState({
        questionStyle: {
          color: "white",
          outlineColor: "black"
        }
      })
    }
    setTimeout(function() {
      if (this.state.mode === "Get Ready!") {
        this.closeResponse();
      }
    }.bind(this), 1);
    setTimeout(function() {
      if (this.state.mode === "Get Ready!") {
        this.setState({
          round: Stroop.round,
        });
        setTimeout(function() {
          Stroop.startRound();
          this.setState({mode: Stroop.mode});
          this.revealSequence(Stroop.revealIndex);
        }.bind(this), 2000);
      }
    }.bind(this), 1);
  }

  closeResponse() {
    Stroop.buttonArray.forEach(button => {
      if (button.active) {
        button.off();
      }
    });
  }

  showSnags() {
    Stroop.updateReadSnags();
    //console.log(Stroop.unreadSnags);
    this.setState({
      showSnags: true,
      snagInfo: Stroop.snagInfo,
      unreadSnags: Stroop.unreadSnags
    });
  }

  hideSnags() {
    Stroop.updateReadSnags();
    //console.log(Stroop.unreadSnags);
    this.setState({
      mode: Stroop.mode,
      showSnags: false,
      unreadSnags: Stroop.unreadSnags,
      questionStyle: {
        color: "white",
        outlineColor: "black"
      }
    });
  }

  componentWillMount() {
    Stroop.loadHighScore();
    this.setState({highScore: Stroop.highScore})
  }

  render() {
    return (
      <div className="screen">
        <Title status={this.state} snagBonus={this.state.snagBonus} showSnags={this.showSnags} hideSnags={this.hideSnags} questionStyle={this.state.questionStyle}/>
        <GameFrame buttons={this.state.buttons} mode={this.state.mode} handleMouseOver={this.handleMouseOver} handleMouseLeave={this.handleMouseLeave} respond={this.respond} rotation={this.state.rotation} showSnags={this.showSnags} hideSnags={this.hideSnags} snagInfo={this.state.snagInfo} snagsToggle={this.state.showSnags} questionStyle={this.state.questionStyle}/>
        <Footer beginGame={this.beginGame} mode={this.state.mode} highScore={this.state.highScore}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js